import { css  } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [70, null, 140],
    background: 'transparent',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s'
  })),
  topScrolled: css(mq({
    height: [44, null, 56],
    background: '#fff',
  })),
  logo: css(mq({
  })),
  logoImg: css(mq({
    display: 'block',
    height: [45, null, 120],
  })),
  logoScrolled: css(mq({
    height: [38, null, 52],

  })),
}